"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = Spinner;
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const styles_1 = require("../styles");
const useStyles = (0, styles_1.createUseThemeStyles)((theme) => ({
    "spinner": {
        width: "var(--spinner-size)",
        height: "var(--spinner-size)",
        border: `calc(var(--spinner-size) / 8) solid color-mix(in oklab, ${theme.palette.light.neutral} 20%, transparent)`,
        borderTopColor: theme.palette.primary.light,
        borderRadius: "50%",
        animation: "$spin 1s linear infinite",
    },
    "@keyframes spin": {
        to: { transform: "rotate(360deg)" },
    },
}));
function Spinner({ size = 48, className }) {
    const classes = useStyles();
    const cssSize = typeof size === "number" ? `${size}px` : size;
    return (React.createElement("div", { className: (0, classnames_1.default)(classes.spinner, className), style: { ["--spinner-size"]: cssSize }, role: "status", "aria-label": "Loading" }));
}
